export default __webpack_public_path__ + "static/media/hero-dev.2a817ae3.jpg";